import { InvoicingQuarter, InvoicingStatistics, InvoicingStatistic, InvoicingStatisticQuotesCount } from '@/app/invoicing/endpoints/StatisticsEndpoint';
import moment, { type MomentInstance } from '@/utils/moment';

export default class InvoicingStatisticsCollection {
    public statistics: InvoicingStatistics;

    constructor(statistics: InvoicingStatistics) {
        this.statistics = statistics;
    }

    getQuarterDateFromKey = (key: string): MomentInstance => {
        const [prefix, quarter, year] = key.split('-');
        return moment().quarter(parseInt(quarter)).year(parseInt(year));
    };

    generateMissingMonthStatistics = (existing: InvoicingStatistic, month: MomentInstance): InvoicingStatistic => {
        const missing: InvoicingStatistic = {};
        Object.keys(existing).forEach((key) => {
            if (key === 'month') {
                missing.month = month.format('YYYY-MM');
            } else if (key === 'quarter') {
                missing.quarter = existing.quarter;
            } else if (key === 'quarters') {
                missing.quarters = [existing.quarter];
            } else if (key === 'quotesCount') {
                missing.quotesCount = {
                    total: 0,
                    accepted: 0,
                    rejected: 0,
                    sent: 0,
                };
            } else {
                missing[key] = 0;
            }
        });
        return missing;
    };

    fillMissingMonths = (quarters: InvoicingQuarter[]) => {
        console.log('Statistics before:', this.statistics);
        this.fillMissingMonthsAtBeginning(quarters);
        this.fillMissingMonthsAtEnd(quarters);
        console.log('Statistics after:', this.statistics);
    };

    fillMissingMonthsAtBeginning = (quarters: InvoicingQuarter[]) => {
        const first = this.statistics[0];
        const firstQuarter = this.getQuarterDateFromKey(first.quarter).startOf('quarter');
        const firstMonth = moment(first.month);
        if (!firstQuarter.isSame(firstMonth, 'month')) {
            this.statistics.unshift(this.generateMissingMonthStatistics(first, firstMonth.subtract(1, 'month')));
            this.fillMissingMonthsAtBeginning(quarters);
        }
    };

    fillMissingMonthsAtEnd = (quarters: InvoicingQuarter[]) => {
        const last = this.statistics[this.statistics.length - 1];
        const lastQuarter = this.getQuarterDateFromKey(last.quarter).endOf('quarter');
        const lastMonth = moment(last.month);
        if (!lastQuarter.isSame(lastMonth, 'month')) {
            this.statistics.push(this.generateMissingMonthStatistics(last, lastMonth.add(1, 'month')));
            this.fillMissingMonthsAtEnd(quarters);
        }
    };

    filterByQuarter = (quarter: InvoicingQuarter) => {
        this.statistics = this.statistics.filter((s) => s.quarters.includes(quarter.key));
    };

    ofType = (type: keyof InvoicingStatistic) => {
        return this.statistics.map((s) => s[type]);
    };

    quotesCountOfType = (type: keyof InvoicingStatisticQuotesCount) => {
        return this.statistics.map((s) => s.quotesCount[type]);
    };

    getMonths(): string[] {
        return this.statistics.map((s) => s.month);
    }

    getTotal = (type: string) => {
        return this.ofType(type).reduce((a, b) => a + b, 0);
    };

    getPercentage = (type: string) => {
        const percentage = (this.getTotal(type) / this.getTotal('totalRevenues')) * 100;

        return Math.round(percentage * 100) / 100;
    };
}
